<template>
    <div class="consultation-clinic">
        <!-- Consultation or Past Consultation -->
        <div v-if="consultationStatus===2 || consultationStatus===4">
            <div id="consultation-container" class="d-flex flex-column">
                <!-- Details -->
                <div id="consultation-details" class="d-flex align-items-baseline">
                    <div class="pl-3 d-flex">
                    <div class="mr-3">
                        <b>Name:</b> {{consultation.participantName}}
                    </div>
                    <div class="mr-3">
                        <b>Gender:</b> {{consultation.patientGender}}
                    </div>
                    <div>
                        <b>Age:</b> {{consultation.patientAge > -1 ? consultation.patientAge : 'Not Specified'}}
                    </div>
                    </div>
                    <!-- <div class="ml-auto">
                        {{consultation.startTime ? convertToUserReadableDateTime(consultation.startTime) : '-'}}
                    </div>
                    <div v-if="isConsultationInProgress">
                        <button class="btn btn-primary btn-primary-insv ml-4">Past Consultations</button>
                    </div> -->
                    <ul class="nav nav-tabs nav-tabs-nowrap ml-auto" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a @click="currentConsultationText = 'Current Consultation'" v-if="isConsultationInProgress" class="nav-link active text-danger" id="consultation-details-tab" data-toggle="tab" href="#consultationDetails" role="tab">
                                {{ currentConsultationText }}
                            </a>
                            <button v-if="$route.query.newTab" class="btn btn-danger btn-danger-insv mb-2 mr-2" @click="closeWindow()">Close</button>
                        </li>
                        <li v-if="isConsultationInProgress" class="nav-item">
                            <a @click="currentConsultationText = 'Back to Current Consultation'" class="nav-link" id="consultation-histories-tab" data-toggle="tab" href="#consultationHistories" role="tab">Previous Consultations
                                <span class="ml-1 badge" :class="{
                                    'badge-primary': consultationList.length > 0,
                                    'badge-secondary':   consultationList.length === 0,
                                }">
                                    {{ consultationList.length}}
                                </span>
                            </a>
                        </li>
                        <li v-if="isConsultationInProgress" class="nav-item">
                            <a @click="currentConsultationText = 'Back to Current Consultation'" class="nav-link" id="medical-reports-tab" data-toggle="tab" href="#medicalReports" role="tab">Medical Reports
                                <span class="ml-1 badge" :class="{
                                    'badge-primary': uploadedReports.length > 0,
                                    'badge-secondary': uploadedReports.length === 0,
                                }">
                                    {{uploadedReports.length}}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- Fields -->
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="consultationDetails" role="tabpanel">
                        <div id="consultation-fields">
                            <!-- First column -->
                            <div class="clinic-consultation-container" style="border-bottom: 1px solid #000000;">
                                <div id="first-col-wrapper" class="row">

                                    <!-- Section 1 -->
                                    <div id="section-1" class="col-6" style="border-right: 1px solid #000000;">
                                        <div class="py-1">
                                            <div class="d-flex justify-content-between">
                                                <p class="mb-2"><b>Notes</b></p>
                                                <i class="fa fa-search search-icon"></i>
                                            </div>
                                            <!-- <div class="mb-2">
                                                <div class="d-flex flex-grow-1">
                                                    <div class="mr-2">
                                                        <label class="label">Family History:</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <textarea :disabled="!isConsultationInProgress" v-model="form.fh" rows="2" type="text" class="form-control"/>
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="mb-2">
                                                <div class="d-flex flex-grow-1">
                                                    <div class="mr-2">
                                                        <label class="label">Allergies:</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <textarea :disabled="!isConsultationInProgress" v-model="form.dal" rows="2" type="text" class="form-control"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="d-flex flex-grow-1">
                                                    <div class="mr-2">
                                                        <label class="label">Medical History:</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <textarea :disabled="!isConsultationInProgress" v-model="form.pai" rows="2" type="text" class="form-control"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="d-flex flex-grow-1">
                                                    <div class="mr-2">
                                                        <label class="label">Special Remarks:</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <textarea :disabled="!isConsultationInProgress" v-model="form.sr" rows="2" type="text" class="form-control"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Section 2 -->
                                    <div id="section-2" class="col-6">
                                        <div class="py-1">
                                            <div class="d-flex justify-content-between">
                                                <p class="mb-2"><b>Physical examination</b></p>
                                                <i class="fa fa-search search-icon"></i>
                                            </div>
                                            <div>
                                                <div class="mb-2">
                                                    <div class="row">
                                                        <div class="col-6 d-flex align-items-baseline">
                                                            <div class="label-width">
                                                                <label class="label" data-toggle="tooltip" data-placement="top" title="Temperature">T:</label>
                                                            </div>
                                                            <input :disabled="!isConsultationInProgress" v-model="form.t" type="number" class="form-control small"/>
                                                            <div class="label-width">
                                                                <span class="unit">°C</span>
                                                            </div>
                                                        </div>

                                                        <div class="col-6 d-flex align-items-baseline">
                                                            <div class="label-width">
                                                                <label class="label" data-toggle="tooltip" data-placement="top" title="Blood Pressure">BP:</label>
                                                            </div>
                                                            <input :disabled="!isConsultationInProgress" v-model="form.bps" type="number" class="form-control small"/>
                                                            <span class="mx-1">/</span>
                                                            <input :disabled="!isConsultationInProgress" v-model="form.bpd" type="number" class="form-control small"/>
                                                            <div class="label-width">
                                                                <span class="unit">mmHg</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="mb-2">
                                                    <div class="row">
                                                        <div class="col-6 d-flex align-items-baseline">
                                                            <div class="label-width">
                                                                <label class="label mr-2" data-toggle="tooltip" data-placement="top" title="Pulse Rate">PR:</label>
                                                            </div>
                                                            <input :disabled="!isConsultationInProgress" v-model="form.pr" type="number" class="form-control small"/>
                                                            <div class="label-width">
                                                                <span class="unit">bpm</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-6 d-flex align-items-baseline">
                                                            <div class="label-width">
                                                                <label class="label" data-toggle="tooltip" data-placement="top" title="Fasting Blood Sugar">FBS:</label>
                                                            </div>
                                                            <input :disabled="!isConsultationInProgress" v-model="form.sl" type="number" class="form-control small"/>
                                                            <div class="label-width">
                                                                <span class="unit">mmol/L</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="mb-2">
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <div class="row">
                                                                <div class="col-6 d-flex align-items-baseline">
                                                                    <div class="mr-2">
                                                                        <label class="label" data-toggle="tooltip" data-placement="top" title="Height">H:</label>
                                                                    </div>
                                                                    <input :disabled="!isConsultationInProgress" v-model="form.h" type="number" class="form-control small"/>
                                                                    <div class="ml-2">
                                                                        <span class="unit">cm</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-6 d-flex align-items-baseline">
                                                                    <div class="mr-2">
                                                                        <label class="label" data-toggle="tooltip" data-placement="top" title="Weight">W:</label>
                                                                    </div>
                                                                    <input :disabled="!isConsultationInProgress" v-model="form.w" type="number" class="form-control small"/>
                                                                    <div class="ml-2">
                                                                        <span class="unit">kg</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-6 d-flex align-items-baseline">
                                                            <div class="label-width">
                                                                <label class="label" data-toggle="tooltip" data-placement="top" title="Body Mass Index">BMI:</label>
                                                            </div>
                                                            <input disabled type="text" :value="bmi" class="form-control small"/>
                                                            <div class="label-width"></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div class="d-flex">
                                                        <div class="label-width">
                                                            <label class="label">Findings:</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <textarea :disabled="!isConsultationInProgress" v-model="form.f" rows="2" type="text" class="form-control"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="clinic-consultation-container" style="border-bottom: 1px solid #000000;">
                            <!-- Second column -->
                                <div id="second-col-wrapper" class="row">

                                    <!-- Section 3 -->
                                    <div id="section-3" class="col-6"  style="border-right: 1px solid #000000;">
                                        <div class="py-1">
                                            <div class="d-flex justify-content-between">
                                                <p class="mb-2"><b>Medicine (Mandatory Field)</b></p>
                                                <i class="fa fa-search search-icon"></i>
                                            </div>
                                            <prescription-detail :isEdit="isConsultationInProgress" v-model="form.prescriptionList"
                                                :pharmacyId="form.pharmacyId" :searchInputClass="{
                                                    'highlight': !warningIncompleteFields.acknowledgedNoMedicine
                                                }"
                                                :drugType="2">
                                                <template slot="additional-content">
                                                    <div class="mt-3">
                                                        <label v-if="validationFormPrescriptionListCount === 0" class="d-flex align-items-center">
                                                            <input type="checkbox" v-model="warningIncompleteFields.acknowledgedNoMedicine">
                                                            <div class="ml-2">I confirm that no medicine will be prescribed for this consultation.</div>
                                                        </label>
                                                    </div>
                                                </template>
                                                <!-- <template v-if="form.prescriptionList.length> 0">
                                                        <form data-vv-scope="prescription-valid-days" @submit.prevent="validatePrescriptionValidDays">
                                                            <div id="prescription" class="d-flex align-items-baseline">
                                                                <label class="mr-2 mb-0">{{ isConsultationInProgress ? "Prescription Valid for (Days):" : "Prescription valid until"}}  </label>
                                                                <input name="prescriptionValidDays" type="text"
                                                                    v-if="isConsultationInProgress"
                                                                    data-vv-validate-on="blur" data-vv-as="prescription valid"
                                                                    v-validate="'required|numeric|min_value:1'"
                                                                    v-model="form.prescriptionValidDays" :class="{
                                                                    'form-control': true,
                                                                    'is-invalid':  validationErrors.has('prescription-valid-days.prescriptionValidDays')
                                                                }">
                                                                <div v-else>
                                                                    {{prescription.validUntil ? convertToUserReadableDate(prescription.validUntil): '-'}}
                                                                </div>
                                                            </div>
                                                        </form>
                                                </template> -->
                                            </prescription-detail>
                                        </div>
                                    </div>

                                    <!-- Section 4 -->
                                    <div id="section-4" class="col-6">
                                        <div class="py-1">
                                            <div class="d-flex justify-content-between">
                                                <p class="mb-1"><b>ICD Codes (Mandatory Field)</b></p>
                                                <i class="fa fa-search search-icon"></i>
                                            </div>
                                            <div v-if="isConsultationInProgress">
                                                <icd-codes :isEdit="true" v-model="form.icdCodes" :inputClass="{
                                                    'highlight': !warningIncompleteFields.acknowledgedNoIcdCode
                                                }"></icd-codes>

                                                <div class="mt-3">
                                                    <label v-if="validationFormIcdCodeListCount === 0" class="d-flex align-items-center">
                                                        <input type="checkbox" v-model="warningIncompleteFields.acknowledgedNoIcdCode">
                                                        <div class="ml-2">I confirm that there's no diagnosis code for this consultation.</div>
                                                    </label>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <p v-if="assignedIcdCodes.length === 0" class="font-italic">
                                                    No assigned ICD 10 Codes.
                                                </p>

                                                <p v-else v-for="(icd, index) in assignedIcdCodes" :key="index">
                                                    <b>{{ icd.code }}</b> - {{ icd.description }}
                                                </p>
                                            </div>

                                            <div class="d-flex justify-content-between">
                                                <p class="mb-1"><b>Medical Procedures / Tests</b></p>
                                            </div>

                                            <div if="isConsultationInProgress" class="mb-2">
                                                <searchable-dropdown
                                                    :maxHeight="200"
                                                    :options="procedureSearch.optionList"
                                                    :isLoading="procedureSearch.isLoadingResult"
                                                    @inputFocus="searchProcedures"
                                                    @search="searchProcedures"
                                                    @selected="selectProcedureDuringConsultation">
                                                </searchable-dropdown>
                                            </div>
                                            <div class="mb-2">
                                                <div>
                                                    <b>
                                                        Selected Medical Procedures / Tests
                                                    </b>
                                                </div>
                                                <p v-if="form.selectedProcedures.length === 0" class="font-italic">
                                                    None
                                                </p>
                                                <ol v-else>
                                                    <li v-for="(procedure, index) in form.selectedProcedures" :key="index">
                                                        [{{ procedure.category }}] {{ procedure.code }} {{ procedure.description }} <a v-if="isConsultationInProgress" class="ml-3" href="javascript:void(0);" @click="deleteConsultationProcedure(index)">Delete</a>
                                                    </li>
                                                </ol>
                                            </div>

                                            <div class="mt-auto mb-2">
                                                <div class="mr-2">
                                                    <label class="label"><b>Advice / Instructions viewing by patient:</b></label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <textarea :disabled="!isConsultationInProgress" rows="3" v-model="form.a" type="text" class="form-control"/>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column" v-if="isConsultationInProgress">
                                                <p v-show="saveErrorMessage" class="text-danger mb-3">{{saveErrorMessage}}</p>
                                                <div>
                                                    <button class="btn btn-primary btn-primary-insv mr-2" type="button" @click="endSession">
                                                        Save and End Session
                                                    </button>
                                                    <router-link :to="{
                                                        'name': 'clinic-patient-queue',
                                                        }" class="btn btn-secondary">
                                                        Back to Consultation List
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="consultationHistories" role="tabpanel">
                        <div class="tab-content-wrapper">
                            <template v-if="consent.isAllowedViewConsultationHistories">
                                <h5 class="mb-3">Consultation Histories</h5>

                                <div>
                                    <div class="table-responsive">
                                        <table class="table table-hover">
                                            <colgroup>
                                                <col width="40">
                                                <col width="140">
                                                <col width="140">
                                                <col>
                                                <col width="400">
                                                <col width="250">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Time</th>
                                                    <th scope="col">Doctor Name</th>
                                                    <th scope="col">ICD Codes</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-show="consultationList.length === 0">
                                                    <td colspan="5" class="text-center font-italic">
                                                        No Data
                                                    </td>
                                                </tr>
                                                <tr v-for="(consultation, index) in consultationList" :key="index">
                                                    <th scope="row">{{index+1}}</th>
                                                    <td class="text-nowrap">{{consultation.date}}</td>
                                                    <td class="text-nowrap">
                                                        {{consultation.time}}
                                                    </td>
                                                    <td>{{consultation.doctorName}}</td>
                                                    <td>
                                                        <template v-if="consultation.icd.length === 0">-</template>
                                                        <template v-else>
                                                            <div class="text-nowrap">
                                                                <div class="d-flex mb-1" v-for="(code, index) in consultation.icd" :key="index">
                                                                    <span class="badge text-nowrap badge-success mr-2">
                                                                        {{ code.c }}
                                                                    </span>
                                                                    <div class="text-truncate" style="max-width: 300px;" :title="code.d">
                                                                        {{ code.d }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </td>
                                                    <td>
                                                        <router-link :to="{
                                                            'name': getConsultationLink(consultation.type),
                                                            'params': {
                                                                'id': consultation.id
                                                                },
                                                            'query': {
                                                                'newTab': true
                                                            }
                                                        }"
                                                        target="_blank">
                                                            View Details
                                                        </router-link>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </template>
                            <div v-else>
                                <p>Patient doesn't allow viewing of previous consultations.</p>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="medicalReports" role="tabpanel">
                        <div class="tab-content-wrapper">
                            <template v-if="consent.isAllowedViewMedicalReports">
                                <h5 class="mb-3">Medical Reports</h5>
                                <table ref="listTable2" class="table table-hover">
                                    <colgroup>
                                        <col width="40">
                                        <col width="200">
                                        <col>
                                        <col width="250">
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Upload Date</th>
                                            <th scope="col">Report Type</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-show="uploadedReports.length === 0">
                                            <td colspan="4" class="text-center font-italic">
                                                No Data
                                            </td>
                                        </tr>
                                        <tr v-for="(report, index) in uploadedReports" :key="index">
                                            <th scope="row">{{index+1}}</th>
                                            <td class="text-nowrap">{{report.date}}</td>
                                            <td class="text-nowrap">{{report.reportType}}</td>
                                            <td class="text-nowrap">
                                                <router-link :to="{'name': 'doctor-medical-report-detail' , 'params': {'id': report.reportId}}" target="_blank">View Report</router-link>
                                                <!-- <a :href="`${apiPath}MedicalReport/DownloadReportById?reportId=${report.reportId}`" target="_blank">Download Report</a> -->
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>
                            <div v-else>
                                <p>Patient doesn't allow viewing of the medical reports.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="End Session">
                <template slot="content">
                    <p v-html="confirmationMessage"></p>
                    <template v-if="warningIncompleteFields.shouldShow">
                        <p><b>Warning:</b></p>
                        <ul>
                            <li v-if="validationFormPrescriptionListCount === 0 && !warningIncompleteFields.acknowledgedNoMedicine">
                                Medicine list is empty.
                            </li>
                            <li v-if="validationFormIcdCodeListCount === 0 && !warningIncompleteFields.acknowledgedNoIcdCode">
                                ICD Code is not assigned.
                            </li>
                        </ul>
                    </template>
                </template>
                <template slot="footer">
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="saveAndEndSession" :disabled="preventSaveAndEndConsultation">Save and End Session</button>
                    <button type="button" class="btn btn-secondary" @click="dismissEndSession">
                        {{ preventSaveAndEndConsultation ? 'Back to Edit' : 'Cancel' }}
                    </button>
                </template>
            </popup-modal>
        </div>

        <!-- Payment -->
        <div v-else-if="consultationStatus===3">
            <h1 class="display-heading">Consultation Session Payment Review</h1>
            <div class="card mb-3">
                <div class="card-body">
                    <appointment-detail participantNameDisplay="Patient Name"
                        :isConsultation="true"
                        :consultationId="consultation.consultationId"
                        :appointmentDate="consultation.startTime"
                        :appointmentParticipant="consultation.participantName"
                        :isDoctor="true"
                        :patientGender="consultation.patientGender"
                        :patientAge="consultation.patientAge">

                        <!-- consultation.doctorName -->
                    </appointment-detail>
                </div>
            </div>

            <div class="mb-3">
                <form data-vv-scope="priceForm">
                    <table class="table table-bordered">
                        <colgroup>
                            <col width="70">
                            <col>
                            <col width="200">
                            <col width="80">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Item</th>
                                <th scope="col" class="text-right">Price (RM)</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <!-- 'name': item.name,
                                'id': item.i,
                                'isEditable': item.ie,
                                'isDeduct': item.d,
                                'price': item.p -->
                        <tbody>
                            <tr v-for="(item, index) in paymentDetails" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{item.name}}</td>
                                <td class="text-right">
                                    <template v-if="item.isEditable">
                                        <div class="input-group">
                                            <input type="text" :name="`item-${item.id}`" class="form-control text-right" v-model.number="item.price"  data-vv-validate-on="blur" :data-vv-as="item.name" v-validate="'required|decimal:2|min_value:0.00'"
                                            :class="{
                                                'is-invalid':  validationErrors.has(`priceForm.item-${item.id}`)
                                            }">
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-success" type="button" @click="resetToDefaultPrice(`item-${item.id}`)"><i class="fas fa-times"></i></button>
                                            </div>
                                            <div v-show="validationErrors.has(`priceForm.item-${item.id}`)" class="invalid-feedback text-left">
                                                {{ validationErrors.first(`priceForm.item-${item.id}`) }}
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{item.price.toFixed(2)}}
                                    </template>
                                </td>
                                <td></td>
                            </tr>
                            <tr v-for="(selectedProcedure, index) in selectedProcedures" :key="`procedure${index}`">
                                <th scope="row">
                                    {{paymentDetails.length+index+1}}
                                </th>
                                <td>
                                    <template v-if="selectedProcedure.isSelectingProcedure">
                                        <searchable-dropdown
                                            :maxHeight="200"
                                            :options="procedureSearch.optionList"
                                            :isLoading="procedureSearch.isLoadingResult"
                                            @inputFocus="searchProcedures"
                                            @search="searchProcedures"
                                            @selected="(selectedProcedureCode) => { procedureSelected(selectedProcedureCode, index) }">
                                        </searchable-dropdown>
                                    </template>
                                    <template v-else>
                                        <b>[{{ selectedProcedure.category }}]</b> {{ selectedProcedure.code }} - {{ selectedProcedure.description }} (Recommended Price: RM {{ selectedProcedure.ceilingPrice.toFixed(2) }})
                                    </template>
                                </td>
                                <td class="text-right">
                                    <div v-if="!selectedProcedure.isSelectingProcedure" class="input-group">
                                        <input :ref="`selectedProcedureItem${index}`" type="text" :name="`procedure-${index}`" class="form-control text-right" v-model.number="selectedProcedure.price"  data-vv-validate-on="blur" data-vv-as="procedure price" placeholder="procedure price" v-validate="`required|decimal:2|min_value:0.01|max_value:${selectedProcedure.ceilingPrice}`"
                                        :class="{
                                            'is-invalid':  validationErrors.has(`priceForm.procedure-${index}`)
                                        }">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-success" type="button" @click="resetProcedurePrice(index)"><i class="fas fa-times"></i></button>
                                        </div>
                                        <div v-show="validationErrors.has(`priceForm.procedure-${index}`)" class="invalid-feedback text-left">
                                            {{ validationErrors.first(`priceForm.procedure-${index}`) }}
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <button class="btn btn-danger" type="button" @click="deleteProcedure(index)">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </td>
                            </tr>
                           <tr>
                               <td></td>
                               <td colspan="2">
                                   <button class="btn btn-primary btn-primary-insv" type="button" @click="addProcedure">
                                       Add Medical Procedure / Test
                                   </button>
                               </td>
                               <td></td>
                           </tr>
                        </tbody>
                        <tfoot>
                            <th colspan="2" scope="row" class="text-right">Total (RM)</th>
                            <td class="text-right">
                                {{paymentSummaryTotal ? paymentSummaryTotal.toFixed(2): (paymentSummaryTotal===0? '0' : 'Invalid Amount')}}
                            </td>
                            <td></td>
                        </tfoot>
                    </table>
                </form>
            </div>

            <template v-if="!mc.generated">
                <div  class="form-check mb-2">
                    <input class="form-check-input" v-model="mc.generate" type="checkbox" value="" id="generateMc">
                    <label class="form-check-label" for="generateMc">
                        Generate MC (Medical Certificate)
                    </label>
                </div>
                <div v-if="mc.generate" class="card mb-3">
                    <div class="card-body">
                        <div class="d-flex align-items-baseline">
                            <span>From</span>
                            <div class="form-group mx-2">
                                <input type="text" name="mcFrom" data-vv-as="from" data-vv-validate-on="blur"
                                    v-model="mc.from"
                                    v-mask="'##/##/####'"
                                    placeholder="DD/MM/YYYY"
                                    :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('mcFrom')
                                }" />
                                <div v-show="validationErrors.has('mcFrom')" class="invalid-feedback">
                                    {{ validationErrors.first('mcFrom') }}
                                </div>
                            </div>
                            <span>To</span>
                            <div class="form-group mx-2">
                                <input type="text" name="mcTo" data-vv-as="from" data-vv-validate-on="blur"
                                    v-model="mc.to"
                                    v-mask="'##/##/####'"
                                    placeholder="DD/MM/YYYY"
                                    :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('mcTo')
                                }" />
                                <div v-show="validationErrors.has('mcTo')" class="invalid-feedback">
                                    {{ validationErrors.first('mcTo') }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <span>Diagnosis: </span>
                            <input type="text" name="diagnosis" data-vv-as="diagnosis" data-vv-validate-on="blur"
                                v-model="mc.diagnosis"
                                placeholder="E.g. Fever, Diarrhea"
                                v-validate="'required'"
                                :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('diagnosis')
                            }" />
                            <div v-show="validationErrors.has('diagnosis')" class="invalid-feedback">
                                {{ validationErrors.first('diagnosis') }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <button class="btn btn-primary btn-primary-insv" type="button" @click="showConfirmPaymentDialog">
                Confirm Payment Details
            </button>

            <popup-modal ref="popupPriceConfirmSuccess" :hasCloseButton="false" title="Confirm Payment Details">
                <template slot="content">
                    <p>{{confirmPriceMessage}}</p>
                </template>
                <template slot="footer">
                    <template v-if="!isSubmittingPrice">
                        <button type="button" class="btn btn-primary btn-primary-insv" @click="confirmPayment">Confirm Payment Details</button>
                        <button type="button" class="btn btn-secondary" @click="dismissConfirmPayment">Cancel</button>
                    </template>
                    <button v-if="isSubmitPriceSuccess" class="button btn btn-primary btn-primary-insv" type="button" @click="redirectToQueuePage">
                        Okay
                    </button>
                </template>
            </popup-modal>

            <popup-modal ref="popupPriceConfirmFailed" :hasCloseButton="false" title="Confirm Payment Details">
                <template slot="content">
                    <p>There's error(s) with the set price. Please review and try again.</p>
                </template>
                <template slot="footer">
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPriceConfirmFailed">Okay</button>
                </template>
            </popup-modal>
        </div>
    </div>
</template>

<script>
import debounce from 'debounce';
import searchableDropdown from '@/components/searchable-dropdown';
import $ from 'jquery';
import moment from 'moment';
import {
    replaceLineBreakInHtml,
    convertToUserReadableDate,
    convertToUserReadableDateTime,
    convertDateToIso8601,
    constructPrescriptionList
} from '@/utilities';
import icdCodes from '@/components/icd-codes';
import prescriptionDetail from '@/components/prescription';
import appointmentDetail from '@/components/appointment-detail';
import twilioVideo from '@/components/twilio-video';
import popupModal from '@/components/popup-modal';
import { VueMaskDirective } from 'v-mask';

export default {
    'name': 'DoctorConsultationDetails',
    'components': {
        icdCodes,
        appointmentDetail,
        prescriptionDetail,
        twilioVideo,
        popupModal,
        searchableDropdown
    },
    'directives': {
        // mask,
        'mask': VueMaskDirective
    },
    'computed': {
        currentPatient () {
            return this.$store.state.currentPatient;
        },
        consultationId () {
            return this.$route.params.id;
        },
        isConsultationInProgress () {
            return this.consultationStatus === 2;
        },
        doctorMemo () {
            return this.form.m ? replaceLineBreakInHtml(this.form.m) : 'NIL';
        },
        doctorComments () {
            return this.form.c ? replaceLineBreakInHtml(this.form.c) : 'NIL';
        },
        doctorDietAdvice () {
            return this.form.da ? replaceLineBreakInHtml(this.form.da) : 'NIL';
        },
        doctorExcerciseAdvice () {
            return this.form.ea ? replaceLineBreakInHtml(this.form.ea) : 'NIL';
        },
        doctorLifestyleAdvice () {
            return this.form.la ? replaceLineBreakInHtml(this.form.la) : 'NIL';
        },
        drugAllergy () {
            return this.form.dal ? replaceLineBreakInHtml(this.form.dal) : 'NIL';
        },
        preExistingIllness () {
            return this.form.pai ? replaceLineBreakInHtml(this.form.pai) : 'NIL';
        },
        currentMedication () {
            return this.form.cm ? replaceLineBreakInHtml(this.form.cm) : 'NIL';
        },
        prescriptionSpecialReminder () {
            return this.form.prescriptionSpecialReminder ? replaceLineBreakInHtml(this.form
                .prescriptionSpecialReminder) : 'NIL';
        },
        procedureDetailsPrice () {
            if (this.selectedProcedures.length === 0) {
                return 0;
            } else {
                if (!this.validationErrors.any('priceForm')) {
                    const reducer = (accumulator, currentValue) => accumulator + currentValue;
                    let procedurePrices = this.selectedProcedures.map((p) => p.price);
                    return procedurePrices.reduce(reducer);
                }
                return null;
            }
        },
        paymentSummaryTotal () {
            if (this.paymentDetails.length === 0) {
                return 0;
            } else {
                if (!this.validationErrors.any('priceForm')) {
                    const reducer = (accumulator, currentValue) => accumulator + currentValue;
                    let paymentPrices = this.paymentDetails.map((p) => p.isDeduct ? (p.price * -1) : p.price);
                    return paymentPrices.reduce(reducer) > 0 ? this.procedureDetailsPrice + paymentPrices.reduce(reducer) : null;
                }
                return null;
            }
        },
        bmi () {
            if (this.form.w && this.form.h) {
                return (this.form.w / ((this.form.h / 100) * (this.form.h / 100))).toFixed(2);
            }

            return null;
        },
        validationFormPrescriptionListCount () {
            return this.form.prescriptionList.length;
        },
        validationFormIcdCodeListCount () {
            return this.form.icdCodes.length;
        },
        preventSaveAndEndConsultation () {
            if (!this.warningIncompleteFields.shouldShow) {
                return false;
            } else {
                return (!this.warningIncompleteFields.acknowledgedNoMedicine) ||
                (!this.warningIncompleteFields.acknowledgedNoIcdCode);
            }
        }
    },
    'watch': {
        consultationStatus (value) {
            if (value === 3) {
                const pageContent = document.getElementsByClassName('page-content');
                pageContent[0].classList.remove('consultation');
                const pageContainer = document.getElementsByClassName('page-container');
                pageContainer[0].classList.remove('consultation');
            }
        },
        validationFormPrescriptionListCount () {
            this.warningIncompleteFields.acknowledgedNoMedicine = false;
        },
        validationFormIcdCodeListCount () {
            this.warningIncompleteFields.acknowledgedNoIcdCode = false;
        },
        previouslyAddedProcedures (list) {
            if (list !== null) {
                list.forEach(procedure => {
                    this.axios.get('ClinicProcedure/Exact', {
                        'params': {
                            'code': procedure
                        }
                    }).then(({ data }) => {
                        const procedureResponse = data.data;
                        if (procedureResponse) {
                            this.selectedProcedures.push({
                                'category': procedureResponse.ca,
                                'code': procedureResponse.c,
                                'description': procedureResponse.d,
                                'ceilingPrice': procedureResponse.p,
                                'price': procedureResponse.p,
                                'isSelectingProcedure': false
                            });
                        }
                    });
                });
            }
        }
    },
    data () {
        return {
            convertToUserReadableDate,
            convertToUserReadableDateTime,
            replaceLineBreakInHtml,
            'form': {
                'fh': null,
                'sr': null,
                't': null,
                'bps': null,
                'bpd': null,
                'pr': null,
                'sl': null,
                'w': null,
                'h': null,
                'f': null,
                'a': null,
                'da': null,
                'ea': null,
                'la': null,
                'm': null,
                'ai': null,
                'c': null,
                'dal': null,
                'pai': null,
                'cm': null,
                'prescriptionList': [],
                'prescriptionValidDays': 0,
                'prescriptionSpecialReminder': null,
                'icdCodes': [],
                'pharmacyId': 'c790b8e8-a595-11ea-a7bf-00163e000d23',
                'selectedProcedures': []
            },
            'prescription': {
                'validUntil': ''
            },
            'consultation': {
                'startTime': null,
                'consultationId': null,
                'participantName': null,
                'doctorName': null,
                'patientGender': '',
                'patientAge': '-1',
                'patientContact': '',
                'patientEmail': ''
            },
            'consultationStatus': 0,
            'twilioToken': null,
            'twilioRoomName': null,
            'isTwilioLoading': true,
            'isTwilioStarted': false,
            'isTwilioJoined': false,
            'twilioStatus': null,
            'startVideoText': 'Please click "Start Video Call Session" to make video call.',
            'waitingVideoText': 'Waiting for patient to connect...',
            'isVideoCallEnded': false,
            'confirmationMessage': null,
            'saveErrorMessage': null,
            'consent': {
                'userId': '',
                'isAllowedViewConsultationHistories': false,
                'isAllowedViewMedicalReports': false
            },
            'consultationList': [],
            'uploadedReports': [],
            'assignedIcdCodes': [],
            'clinicPaymentId': 0,
            'paymentDetails': [],
            'confirmPriceMessage': '',
            'isSubmittingPrice': false,
            'isSubmitPriceSuccess': false,
            'currentConsultationText': 'Current Consultation',
            'mc': {
                'generate': false,
                // 'generated': false,
                'diagnosis': '',
                'from': moment().format('DD/MM/YYYY'),
                'to': moment().format('DD/MM/YYYY')
            },
            'procedureSearch': {
                'procedureList': [],
                'optionList': [],
                'isLoadingResult': false,
                'keyword': null
            },
            'selectedProcedures': [],
            'warningIncompleteFields': {
                'shouldShow': false,
                'acknowledgedNoMedicine': false,
                'acknowledgedNoIcdCode': false
            },
            'previouslyAddedProcedures': []
        };
    },
    mounted () {
        // this.consultationStatus = 2;

        if (this.$route.name === 'clinic-consultation-details') {
            this.consultation.startTime = new Date().toLocaleString();
            this.consultation.consultationId = '-';
            this.getQueueData();
        } else if (this.$route.name === 'clinic-past-consultation-details') {
            this.getConsultationData();
        }

        // Add class to page-content and page-container to remove padding
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('consultation');
        const pageContainer = document.getElementsByClassName('page-container');
        pageContainer[0].classList.add('consultation');

        const body = document.body;
        body.classList.add('no-top-navigation');

        // Init Tooltips
        $('[data-toggle="tooltip"]').tooltip();

        // #region search procedures
        let vm = this;
        this.searchProcedures = debounce((text) => {
            vm.procedureSearch.procedureList = [];

            vm.isLoadingResult = true;
            // call ajax here
            vm.axios.get('ClinicProcedure/Search',
                { 'params': {
                    'keyword': text || ''
                } })
                .then(({ data }) => {
                    vm.procedureSearch.procedureList = data.data.map((procedure) => ({
                        'code': procedure.c,
                        'category': procedure.ca,
                        'description': procedure.d,
                        'ceilingPrice': procedure.p
                    }));

                    vm.procedureSearch.isLoadingResult = false;
                    vm.procedureSearch.optionList = vm.procedureSearch.procedureList.map((procedure) => ({
                        'value': procedure.code,
                        'text': `[${procedure.category}] ${procedure.code} - ${procedure.description} (Recommended Price: RM${procedure.ceilingPrice})`
                    }));
                });
        }, 300);
        // #endregion search procedure
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('consultation');
        const pageContainer = document.getElementsByClassName('page-container');
        pageContainer[0].classList.remove('consultation');

        const body = document.body;
        body.classList.remove('no-top-navigation');
    },
    'methods': {
        getQueueData () {
            this.axios.post('Clinic/GetQueueDetails', {
                'queueId': this.consultationId
            }).then(({ data }) => {
                let queueData = data.data;
                this.consultation.participantName = queueData.patientName;
                this.consultation.patientGender = queueData.patientGenderDisplay;
                this.consultation.patientAge = queueData.patientAge;
                this.consultationStatus = queueData.status;
                this.consultation.startTime = queueData.startTime;
                this.consultation.consultationId = queueData.clinicConsultationIdShort;

                this.form.dal = queueData.drugAllergy;
                this.form.pai = queueData.preExistingIllnesses;
                this.form.fh = queueData.familyHistory;
                this.form.sr = queueData.specialRemarks;

                this.clinicPaymentId = queueData.clinicPaymentId;
                if (queueData.payment && queueData.payment.psi) {
                    let paymentList = queueData.payment.psi;
                    this.paymentDetails = paymentList.map((item) => ({
                        'name': item.in,
                        'id': item.i,
                        'isEditable': item.ie,
                        'isDeduct': item.d,
                        'price': item.ip
                    }));
                }

                this.consent.userId = queueData.patientId;
                this.consentViewConsultationHistories();
                this.consentViewMedicalReports();
                // this.mc.generated = queueData.generatedMc;

                this.previouslyAddedProcedures = queueData.clinicProcedures;
            });
        },
        getConsultationData () {
            this.axios.get('Consultation/GetClinicConsultation', {
                'params': {
                    'consultationId': this.consultationId
                }
            }).then(({ data }) => {
                let consultation = data.data;

                this.consultation.startTime = consultation.st;
                this.consultation.consultationId = consultation.cis;
                this.consultation.participantName = consultation.u ? consultation.u.fn : null;
                this.consultation.doctorName = consultation.d ? consultation.d.n : null;
                this.consultation.patientGender = consultation.u ? consultation.u.g : null;
                this.consultation.patientAge = consultation.u ? consultation.u.a : -1;
                this.consultation.patientContact = consultation.u ? consultation.u.pn : null;
                this.consultation.patientEmail = consultation.u ? consultation.u.e : null;

                this.form.dal = consultation.dal;
                this.form.pai = consultation.pai;
                this.form.fh = consultation.fh;
                this.form.sr = consultation.sr;
                this.form.t = consultation.t;
                this.form.bps = consultation.bps;
                this.form.bpd = consultation.bpd;
                this.form.pr = consultation.pr;
                this.form.sl = consultation.sl;
                this.form.w = consultation.w;
                this.form.h = consultation.h;
                this.form.f = consultation.f;
                this.form.a = consultation.a;

                this.consultationStatus = 4;

                this.consent.userId = consultation.ui;

                // this.form.pharmacyId = consultation.phid;

                this.initializePrescriptionList(consultation.p);
                this.consentViewConsultationHistories();
                this.consentViewMedicalReports();

                if (consultation.icds) {
                    this.assignedIcdCodes = consultation.icds.map((icd) => {
                        return {
                            'code': icd.c,
                            'description': icd.d
                        };
                    });
                }
            });
        },
        initializePrescriptionList (prescription) {
            if (prescription && prescription.pil) {
                this.form.prescriptionList = constructPrescriptionList(prescription.pil);
            }
            if (prescription && prescription.vu) {
                this.prescription.validUntil = prescription.vu;
            }

            if (prescription && prescription.sr) {
                this.form.prescriptionSpecialReminder = prescription.sr;
            }
        },
        async endSession () {
            // if (this.mc.generate) {
            //     const valid = await this.$validator.validate('diagnosis');
            //     if (!valid) {
            //         this.saveErrorMessage =
            //                 'You have error(s) in the form. Please check the input(s) before saving...';
            //         this.$nextTick(() => {
            //             let errorInput = document.querySelector('.is-invalid');

            //             if (errorInput) {
            //                 errorInput.focus();
            //             }
            //         });
            //         return 0;
            //     }
            // }

            if ((this.validationFormPrescriptionListCount === 0 && !this.warningIncompleteFields.acknowledgedNoMedicine) ||
            (this.validationFormIcdCodeListCount === 0 && !this.warningIncompleteFields.acknowledgedNoIcdCode)) {
                this.warningIncompleteFields.shouldShow = true;
            } else {
                this.warningIncompleteFields.shouldShow = false;
            }

            this.saveErrorMessage = '';
            this.confirmationMessage = this.warningIncompleteFields.shouldShow ? 'Cannot save consultation details.' : 'Are you sure you want to end this session?';
            this.$refs.popupModalConfirmation.show();

            // else {
            //     this.saveErrorMessage =
            //                 'You have error(s) in the form. Please check the input(s) before saving...';
            //     this.$nextTick(() => {
            //         let errorInput = document.querySelector('.is-invalid');

            //         if (errorInput) {
            //             errorInput.focus();
            //         }
            //     });
            // }
        },
        dismissEndSession () {
            this.$refs.popupModalConfirmation.hide();
        },
        saveAndEndSession () {
            this.confirmationMessage = 'Saving consultation data...';

            let prescriptionList = [];
            prescriptionList = this.form.prescriptionList.map((item) => ({
                'di': item.drugId,
                'q': item.quantity,
                'fd': item.consumptionFrequency,
                'qc': item.quantityPerConsumption,
                'si': null,
                'sr': null
            }));

            let prescriptionDetails = prescriptionList.length === 0 ? null : {
                'pl': prescriptionList,
                'pvd': this.form.prescriptionValidDays,
                'sr': this.form.prescriptionSpecialReminder
            };

            const clinicProcedures = this.form.selectedProcedures.map((procedure) => {
                return procedure.code;
            });

            this.axios.post('Clinic/FinalizeConsultation', {
                'queueId': this.consultationId,
                'iCDCodes': this.form.icdCodes,
                'prescriptionDetails': prescriptionDetails,
                'drugAllergy': this.form.dal,
                'preExistingIllnesses': this.form.pai,
                'familyHistory': this.form.fh,
                'specialRemarks': this.form.sr,
                'temperature': this.form.t,
                'systolic': this.form.bps,
                'diastolic': this.form.bpd,
                'pulseRate': this.form.pr,
                'sugarLevel': this.form.sl,
                'weight': this.form.w,
                'height': this.form.h,
                'findings': this.form.f,
                'advice': this.form.a,
                'clinicProcedures': clinicProcedures
            }).then(({
                data
            }) => {
                this.$refs.popupModalConfirmation.hide(() => {
                    // this.$router.push({
                    //     'name': 'clinic-consultation-list'
                    // });
                    this.getQueueData();
                });
            }).catch((error) => {
                if (error && error.response) {
                    if (error.response.data) {
                        this.confirmationMessage = error.response.data.message;
                    } else {
                        this.confirmationMessage =
                                    'Error saving consultation, please try again.';
                    }
                } else {
                    this.confirmationMessage =
                                    'Error saving consultation, please try again.';
                }
            });
        },
        async showConfirmPaymentDialog () {
            // if (this.mc.generate && !this.mc.generated) {
            //     const valid = await this.$validator.validate('diagnosis');
            //     if (!valid) {
            //         this.saveErrorMessage =
            //             'You have error(s) in the form. Please check the input(s) before saving...';
            //         this.$nextTick(() => {
            //             let errorInput = document.querySelector('.is-invalid');

            //             if (errorInput) {
            //                 errorInput.focus();
            //             }
            //         });
            //         return 0;
            //     }
            // }

            const isValid = await this.$validator.validateAll('priceForm');
            if (isValid && this.paymentSummaryTotal !== null) {
                this.confirmPriceMessage = 'Are you sure you want to save the payment details? This action cannot be undone.';
                this.$refs.popupPriceConfirmSuccess.show();
            } else {
                this.$refs.popupPriceConfirmFailed.show();
            }
        },
        confirmPayment () {
            this.isSubmittingPrice = true;
            this.confirmPriceMessage = 'Submitting payment details...';

            let paymentItems = this.paymentDetails.filter(pd => pd.isEditable);

            let updateItems = paymentItems.map((item) => ({
                'ii': item.id,
                'ip': item.price
            }));

            let clinicProcedures = this.selectedProcedures.map((cp) => ({
                'cp': cp.code,
                'ip': cp.price
            }));

            this.axios.post('Clinic/ConfirmPayment', {
                'pi': this.clinicPaymentId,
                'cpi': updateItems,
                'cpl': clinicProcedures,
                'gmc': this.mc.generate,
                'mcf': convertDateToIso8601(this.mc.from),
                'mct': convertDateToIso8601(this.mc.to),
                'mcd': this.mc.diagnosis
            }).then(() => {
                this.confirmPriceMessage = 'Successfully confirmed payment details!';
                this.isSubmitPriceSuccess = true;
            }).catch((err) => {
                this.isSubmittingPrice = false;
                if (err.response && err.response.data && err.response.data.data && err.response.data.data.error) {
                    this.confirmPriceMessage = err.response.data.data.error;
                } else {
                    this.confirmPriceMessage = 'Error saving payment details. Please try again.';
                }
            });
        },
        dismissConfirmPayment () {
            this.$refs.popupPriceConfirmSuccess.hide();
        },
        dismissPriceConfirmFailed () {
            this.$refs.popupPriceConfirmFailed.hide();
        },
        redirectToQueuePage () {
            this.$refs.popupPriceConfirmSuccess.hide().then(() => {
                this.$router.push({
                    'name': 'clinic-patient-queue'
                });
            });
        },
        consentViewConsultationHistories () {
            // this.consent.isAllowedViewConsultationHistories = isConscentGiven;

            // if (isConscentGiven) {
            this.axios.post('ConsentService/GetConsentConsultationHistories', {
                'gi': this.consent.userId
            }).then(({ data }) => {
                this.consent.isAllowedViewConsultationHistories = true;
                this.consultationList = data.data.map((consultation) => ({
                    'id': consultation.consultationId,
                    'date': consultation.datetime ? moment(consultation.datetime).format('DD/MM/YYYY') : null,
                    'time': consultation.datetime ? moment(consultation.datetime).format('hh:mm A') : null,
                    'doctorName': consultation.doctorName ? consultation.doctorName : '-',
                    'type': consultation.type,
                    'icd': consultation.icdCodes
                }));
            }).catch(() => {
                this.consent.isAllowedViewConsultationHistories = false;
            });
            // }
        },
        consentViewMedicalReports () {
            // this.consent.isAllowedViewMedicalReports = isConscentGiven;

            // if (isConscentGiven) {
            this.axios.post('ConsentService/GetConsentMedicalReports', {
                'gi': this.consent.userId
            }).then(({ data }) => {
                this.consent.isAllowedViewMedicalReports = true;
                this.uploadedReports = data.data.map((report) => ({
                    'date': convertToUserReadableDate(report.ud),
                    'reportType': report.rt,
                    'reportId': report.ri
                }));
            }).catch(() => {
                this.consent.isAllowedViewMedicalReports = false;
            });
            // }
        },
        getConsultationLink (consultationType) {
            if (consultationType === 1) {
                return 'doctor-consultation-detail';
            } else if (consultationType === 2) {
                return 'doctor-consultation-no-pharmacy-detail';
            } else {
                return 'clinic-past-consultation-details';
            }
        },
        closeWindow () {
            window.close();
        },
        resetToDefaultPrice (inputName) {
            let input = document.querySelector(`input[name=${inputName}`);
            input.value = 0;

            this.$nextTick(() => {
                input.dispatchEvent(new Event('input'));
                input.focus();
            });
        },
        addProcedure () {
            this.selectedProcedures.push({
                'category': '',
                'code': '',
                'description': '',
                'ceilingPrice': 0,
                'price': 0,
                'isSelectingProcedure': true
            });
        },
        deleteProcedure (index) {
            this.selectedProcedures.splice(index, 1);
        },
        procedureSelected (selectedProcedureCode, rowIndex) {
            let selectedProcedureDetails = this.procedureSearch.procedureList.find(p => p.code === selectedProcedureCode);

            if (selectedProcedureDetails) {
                this.selectedProcedures[rowIndex].category = selectedProcedureDetails.category;
                this.selectedProcedures[rowIndex].code = selectedProcedureDetails.code;
                this.selectedProcedures[rowIndex].description = selectedProcedureDetails.description;
                this.selectedProcedures[rowIndex].ceilingPrice = selectedProcedureDetails.ceilingPrice;
                this.selectedProcedures[rowIndex].price = selectedProcedureDetails.ceilingPrice;
                this.selectedProcedures[rowIndex].isSelectingProcedure = false;
            }
        },
        resetProcedurePrice (index) {
            this.selectedProcedures[index].price = this.selectedProcedures[index].ceilingPrice;

            this.$nextTick(() => {
                this.$validator.validateAll('priceForm').then((e) => {
                });
            });
        },
        selectProcedureDuringConsultation (selectedProcedureCode) {
            let selectedProcedureDetails = this.procedureSearch.procedureList.find(p => p.code === selectedProcedureCode);

            this.form.selectedProcedures.push(selectedProcedureDetails);
        },
        deleteConsultationProcedure (index) {
            this.form.selectedProcedures.splice(index, 1);
        }
    }
};

</script>

<style scoped>
    .consultation-clinic {
        min-height: 100vh;
    }

    label {
        font-size: 12px;
    }

    /* #consultation-container {
        /* min-height: calc(710px - 64px - 24px);
        height: calc(100vh - 64px - 24px);
        min-width: calc(1366px - 250px);
    } */

    #consultation-details {
        border-bottom: 1px solid grey;
        padding-top: 5px;
    }

    #consultation-details button {
        font-size: 12px;
        padding: 5px;
    }

    #consultation-fields {
        /* background: lightgreen; */
    }

    #section-1 {
        /* border-bottom: 0.5px solid grey; */
        /* flex-basis: 0;
        padding: 5px;
        font-size: 14px; */
    }

    #section-1 .label {
        width: 120px;
    }

    #section-1 textarea {
        font-size: 11px;
    }

    #section-2 {
        /* border-top: 0.5px solid grey;
        flex-basis: 0;
        padding: 5px;
        font-size: 14px; */
    }

    #section-2 .small {
        /* width: 50px; */
        font-size: 12px;
        padding: 5px;
    }

    #section-2 input {
        font-size: 14px;
    }

    #section-2 .unit {
        font-size: 12px;
    }

    #section-2 textarea {
        font-size: 12px;
    }

    #section-3 {
        /* font-size: 14px;
        border-bottom: 0.5px solid grey;
        flex-basis: 0;
        padding: 5px; */
    }

    #section-3 #prescription {
        font-size: 11px;
    }

    #section-3 #prescription input {
        padding: 0 5px 0 5px;
        font-size: 11px;
        width: 40px;
    }

    #section-4 {
        /* border-top: 0.5px solid grey;
        flex-basis: 0;
        padding: 5px;
        font-size: 14px; */
    }

    #section-4 textarea {
        font-size: 11px;
    }

    .search-icon {
        color: #009344;
        display: none; /* Remove when working on maginfying function */
    }

    .search-icon:hover {
        cursor: pointer;
    }

    .label-width {
        width: 60px;
        flex-grow: 0;
        flex-shrink: 0;
    }

    .label-width:first-child {
        margin-right: 10px;
    }

    .label-width:last-child {
        margin-left: 10px;
    }

    .clinic-consultation-container {
        padding-left: 15px;
        padding-right: 15px;
    }
</style>
